<template>
  <div>
    <div v-for="(item, index) in dataList" :key="(item.dispatchNumber +'-'+ index)" class="wrap-style">
      <table border="1" class="table-style">
        <tr>
          <!-- colSpan 用来合并列-->
          <!-- rowSpan 用来合并行-->
          <td colSpan="8" class="tac">{{ printTitle(item) }}</td>
        </tr>
        <tr>
          <td colSpan="2">派工单号：</td>
          <td colSpan="2">{{ item.dispatchNumber }}</td>
          <td colSpan="4" rowSpan="6" class="qrCode">
            <div class="qrCode-border">
              <QrCode :id="('qrCode'+item.dispatchNumber + '-' + index)" :text="item.dispatchNumber" width="150" height="150" ref="qrCode" />
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan="2">工单号：</td>
          <td colSpan="2">{{ item.wipEntityName }}</td>
        </tr>
        <tr>
          <td colSpan="2">物料类别：</td>
          <td colSpan="2">{{ item.itemType }}</td>
        </tr>
        <tr>
          <td colSpan="2">颜色：</td>
          <td colSpan="2">{{ item.colour }}</td>
        </tr>
        <tr>
          <td colSpan="2">物料编码：</td>
          <td colSpan="2">{{ item.productCode }}</td>
        </tr>
        <tr>
          <td colSpan="2">物料名称：</td>
          <td colSpan="2">{{ item.itemName }}</td>
        </tr>
        <tr>
          <td colSpan="2">规格描述：</td>
          <td colSpan="6">{{ item.description }}</td>
        </tr>

        <tr>
          <td colSpan="2">下达日期：</td>
          <td colSpan="2">{{ item.dispatchingDate }}</td>
          <td colSpan="2">一次达交考核时间：</td>
          <td colSpan="2">{{ item.deliveryDate }}</td>
        </tr>
        <tr>
          <td colSpan="2"></td>
          <td colSpan="2"></td>
          <td colSpan="2">变更后考核交期：</td>
          <td colSpan="2">{{ item.assessmentDeliveryDate }}</td>
        </tr>
        <tr>
          <td colSpan="2">计划开始时间：</td>
          <td colSpan="2">{{ item.scheduledStartDate }}</td>
          <td colSpan="2">计划完成时间：</td>
          <td colSpan="2">{{ item.scheduledCompletionDate }}</td>
        </tr>
        <tr>
          <td colSpan="2">订单号：</td>
          <td colSpan="2">{{ item.orderNo }}</td>
          <td colSpan="2">任务数量：</td>
          <td colSpan="2">{{ item.numberOfTasks }} {{ `( 佛山仓: ${item.finishedProductQty} 基地仓: ${item.baseQty} 佛山专货仓：${item.currentFszhcDivideQty} 卫星仓：${item.wxcQty} 基地仓理货：${item.jdc002Qty} )` }}</td>
        </tr>
        <tr>
          <td colSpan="2">批次号：</td>
          <td colSpan="2">{{ item.batchNumber }}</td>
          <td colSpan="2">制造商：</td>
          <td colSpan="2">{{ item.vendorCode }}</td>
        </tr>
        <tr>
          <td colSpan="2">组装中心：</td>
          <td colSpan="2">{{ finishedProductJobOrgVal(item) }}</td>
          <td colSpan="2">托套比：</td>
          <td colSpan="2">{{ item.palletStandardQty }}</td>
        </tr>
        <tr>
          <td colSpan="2">车间：</td>
          <td colSpan="2">{{ item.workCode }}</td>
          <td colSpan="2">产线：</td>
          <td colSpan="2">{{ item.prodLineCode }}</td>
        </tr>
        <tr>
          <td colSpan="8" class="tac">工序报工</td>
        </tr>
        <tr>
          <td class="tac">工序编码</td>
          <td class="tac">工序名称</td>
          <td class="tac">派工数量</td>
          <td class="tac">完工数量</td>
          <td class="tac">质检状态</td>
          <td class="tac">工序类型</td>
          <td colSpan="2" class="tac">员工姓名/组</td>
        </tr>
        <tr v-for="item2 in item.processReportingVOList" :key="item2.procedureCode">
          <td class="tac">{{ item2.operationCode }}</td>
          <td class="tac">{{ item2.operationDesc }}</td>
          <td class="tac">{{ item2.dispatchQty }}</td>
          <td class="tac"></td>
          <td class="tac"></td>
          <td class="tac">{{ item2.operationTypeName }}</td>
          <td colSpan="2" class="tac"></td>
        </tr>

        <tr>
          <td colSpan="8" class="tac">用料清单</td>
        </tr>
        <tr>
          <td class="tac">物料编码</td>
          <td colSpan="5" class="tac">物料名称</td>
          <td colSpan="2" class="tac">需求数量</td>
        </tr>

        <tr v-for="item3 in item.materialListVOList" :key="item3.itemId">
          <td class="tac">{{ item3.itemCode }}</td>
          <td colSpan="5" class="tac">{{ item3.itemName }}</td>
          <td colSpan="2" class="tac">{{ item3.requiredQuantity }}</td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index'

export default {
  components: {
    QrCode
  },
  props: {},
  data () {
    return {
      dataList: []
    }
  },
  created () {},
  methods: {
    // 打印标题
    printTitle(item) {
      // 当工单类型为“五金工单”，且计划单号前缀为“PSLJ”时，打印标题改为派工资料（送产业园）；前缀为“PSCP”时，标题改完派工资料（送佛山仓）
      if(item?.jobType === 'WJ_STANDARD') {
        if(item?.orderNo?.startsWith("PSLJ")) { return '派工资料（送产业园）' }
        if(item?.orderNo?.startsWith("PSCP")) { return '派工资料（送佛山仓）' }
      }
      return `派工资料（${item.wipEntityFlag}）`
    },
    // 组装中心修改，当工单类型为“五金工单”，且计划单号前缀为“PSLJ”或“PSCP”时，组装中心不展示
    finishedProductJobOrgVal(item) {
      if(item?.jobType === 'WJ_STANDARD' && (item?.orderNo?.startsWith("PSLJ") || item?.orderNo?.startsWith("PSCP"))) { return '' }
      return item.finishedProductJobOrg
    },
    show (val) {
      this.dataList = val
    }
  }
}
</script>

<style scoped lang="less">
.wrap-style{
  page-break-after: always;
  padding: 10px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.qrCode{
  padding-left: 70px;
}
.qrCode-border{
  border: 1px solid #efefef;
  width: 160px;
  height: 160px;
  padding: 5px;
}
</style>
